import { render, staticRenderFns } from "./InactiveFeature.vue?vue&type=template&id=8a94b5de&scoped=true&"
import script from "./InactiveFeature.vue?vue&type=script&lang=js&"
export * from "./InactiveFeature.vue?vue&type=script&lang=js&"
import style0 from "./InactiveFeature.vue?vue&type=style&index=0&id=8a94b5de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a94b5de",
  null
  
)

export default component.exports